
import axios from "axios";
import log from "loglevel";
import { DLValue, Version } from "./Conf";
import Helpers from "./Helpers";

export async function remoteLogDatadog(logger: log.RootLogger) {
    try {
        if (!logger || !logger.methodFactory) {
            throw new Error(
                "loglevel instance has to be specified in order to be extended"
            );
        }

        logger.methodFactory = function (methodName: string) {
            let postfix = "dev";
            if (window.location.host === "app.ritmocafe.com") {
                postfix = "prod";
            } else if (window.location.host === "localhost") {
                postfix = "local";
            }
            const user: any = Helpers.UserGet()
            return function (message: string) {
                //const currentUser = Token.GetUserInfo()
                const payload = {
                    message,
                    status: methodName,
                    source: "browser",
                    host: `wapp-home:${postfix}`,
                    service: "wapp-home",
                    version: Version,
                    localBrowser: navigator.userAgent,
                    languages: navigator.languages,
                    loggedUser: user ? user.email : '',
                    url: window.location.href,
                };

                axios
                    .post(
                        `https://http-intake.logs.datadoghq.eu/v1/input/${DLValue}`,
                        payload
                    )
                    .catch((error) => {
                        console.error(
                            "Failed to call to datadog with this payload",
                            payload
                        );
                        console.error(error);
                        throw error;
                    });
            };
        };
    } catch (err) {
        console.error("Error: ", err);
    }
}
